const NODES = [
  { cx: 420, cy: 35, r: 2.5, delay: 0 },
  { cx: 340, cy: 95, r: 2, delay: 0.4 },
  { cx: 560, cy: 55, r: 2.5, delay: 0.8 },
  { cx: 640, cy: 35, r: 2, delay: 1.2 },
  { cx: 620, cy: 85, r: 2, delay: 1.6 },
  { cx: 750, cy: 65, r: 2, delay: 2.0 },
  { cx: 240, cy: 22, r: 1.5, delay: 2.4 },
  { cx: 480, cy: 16, r: 1.5, delay: 2.8 },
] as const

const LINES = [
  'M 70 104 Q 250 56 420 35',
  'M 70 104 Q 220 104 340 95',
  'M 70 104 Q 360 86 560 55',
  'M 420 35 Q 540 22 640 35',
  'M 560 55 Q 660 45 750 65',
  'M 340 95 Q 480 88 620 85',
  'M 640 35 Q 700 50 750 65',
] as const

export const InviteAFriendHeroArt = () => (
  <svg
    className="absolute inset-0 w-full h-full text-primary pointer-events-none rtl:-scale-x-100"
    viewBox="0 0 800 120"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <g
      stroke="currentColor"
      strokeOpacity="0.22"
      fill="none"
      strokeWidth="0.6"
      strokeDasharray="2 3"
    >
      {LINES.map((d, i) => (
        <path key={i} d={d}>
          <animate
            attributeName="stroke-dashoffset"
            values="0;-50"
            dur={`${14 + i * 1.5}s`}
            repeatCount="indefinite"
          />
        </path>
      ))}
    </g>

    <g fill="currentColor" fillOpacity="0.5">
      {NODES.map((n, i) => (
        <circle key={i} cx={n.cx} cy={n.cy} r={n.r}>
          <animate
            attributeName="opacity"
            values="0.3;1;0.3"
            dur="3.6s"
            repeatCount="indefinite"
            begin={`${n.delay}s`}
          />
        </circle>
      ))}
    </g>

    <g fill="currentColor" className="max-sm:hidden">
      <circle cx="70" cy="104" r="4" opacity="0.4">
        <animate attributeName="r" values="4;16;4" dur="3.6s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.5;0;0.5" dur="3.6s" repeatCount="indefinite" />
      </circle>
      <circle cx="70" cy="104" r="4.5" />
    </g>

    <path id="refer-plane-path" d="M 70 104 Q 280 36 560 55" fill="none" stroke="none" />

    <g fill="currentColor" className="max-sm:hidden">
      <g transform="translate(-9, -8)">
        <path d="M 0 0 L 18 8 L 0 16 L 5 8 Z" />
      </g>
      <animateMotion dur="6s" repeatCount="indefinite" rotate="auto" begin="0.5s">
        <mpath href="#refer-plane-path" />
      </animateMotion>
      <animate
        attributeName="opacity"
        values="0;1;1;0"
        keyTimes="0;0.12;0.85;1"
        dur="6s"
        repeatCount="indefinite"
        begin="0.5s"
      />
    </g>
  </svg>
)
